// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"09a3a5c8","294":"c0b6bd66","310":"e5721125","383":"c88d1cd4","537":"1a6eaccb","657":"59317f1b","682":"a2dccde5","772":"45703eac","965":"d9e7977d"}[chunkId] + ".chunk.js";
};